export enum PAYMENT_METHOD_TYPE {
  BACKUP = 'backup',
  PRIMARY = 'primary',
}

export enum PAYMENT_TYPES {
  CREDIT_CARD = 'credit_card',
  APPLE_PAY = 'apple_pay',
  PAYPAL = 'paypal_billing_agreement',
}

export enum CARD_TYPES {
  MasterCard = 'master-card',
  Visa = 'visa',
  'American Express' = 'amex',
  ApplePay = 'applepay',
  PayPal = 'paypal',
}
